type KnightProps = {
    className?: string;
};

export default function Knight({ className }: KnightProps) {
    return (
        <svg
            className={className}
            viewBox="0 0 70 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.4539 16.4801C50.6593 18.0801 59.9194 29.2801 59.1478 62.8801H23.6504C23.6504 48.4801 39.084 52.4801 35.9973 29.2801"
                fill="currentColor"
            />
            <path
                d="M34.4539 16.4801C50.6593 18.0801 59.9194 29.2801 59.1478 62.8801H23.6504C23.6504 48.4801 39.084 52.4801 35.9973 29.2801"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.5403 29.2801C38.1268 33.9361 28.9747 41.0721 25.1934 43.6801C20.5633 46.8801 20.8411 50.6241 17.4766 50.0801C15.8684 48.5761 19.6527 45.2161 17.4766 45.2801C15.9332 45.2801 17.7698 47.2481 15.9332 48.4801C14.3899 48.4801 9.75514 50.0801 9.75977 42.0801C9.75977 38.8801 19.02 22.8801 19.02 22.8801C19.02 22.8801 21.9369 19.8401 22.1067 17.2801C20.98 15.6897 21.335 14.0801 21.335 12.4801C22.8784 10.8801 25.9651 16.4801 25.9651 16.4801H29.0518C29.0518 16.4801 30.2556 13.2929 32.9102 11.6801C34.4536 11.6801 34.4536 16.4801 34.4536 16.4801"
                fill="currentColor"
            />
            <path
                d="M37.5403 29.2801C38.1268 33.9361 28.9747 41.0721 25.1934 43.6801C20.5633 46.8801 20.8411 50.6241 17.4766 50.0801C15.8684 48.5761 19.6527 45.2161 17.4766 45.2801C15.9332 45.2801 17.7698 47.2481 15.9332 48.4801C14.3899 48.4801 9.75514 50.0801 9.75977 42.0801C9.75977 38.8801 19.02 22.8801 19.02 22.8801C19.02 22.8801 21.9369 19.8401 22.1067 17.2801C20.98 15.6897 21.335 14.0801 21.335 12.4801C22.8784 10.8801 25.9651 16.4801 25.9651 16.4801H29.0518C29.0518 16.4801 30.2556 13.2929 32.9102 11.6801C34.4536 11.6801 34.4536 16.4801 34.4536 16.4801"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1625 41.2801C15.1625 41.4923 15.0812 41.6958 14.9365 41.8458C14.7918 41.9958 14.5955 42.0801 14.3908 42.0801C14.1862 42.0801 13.9899 41.9958 13.8452 41.8458C13.7004 41.6958 13.6191 41.4923 13.6191 41.2801C13.6191 41.0679 13.7004 40.8644 13.8452 40.7144C13.9899 40.5644 14.1862 40.4801 14.3908 40.4801C14.5955 40.4801 14.7918 40.5644 14.9365 40.7144C15.0812 40.8644 15.1625 41.0679 15.1625 41.2801Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.5462 25.68C23.2392 26.2313 22.8744 26.7178 22.532 27.0325C22.1896 27.3473 21.8977 27.4645 21.7204 27.3584C21.5432 27.2523 21.4952 26.9316 21.5869 26.4668C21.6787 26.0021 21.9027 25.4313 22.2097 24.88C22.5167 24.3288 22.8815 23.8423 23.2239 23.5275C23.5663 23.2128 23.8582 23.0955 24.0355 23.2016C24.2127 23.3077 24.2607 23.6284 24.169 24.0932C24.0772 24.558 23.8532 25.1288 23.5462 25.68Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
